module.exports = __webpack_public_path__ + "img/speaker_2.99d5cae0.png";